import React, { useEffect, useRef, useState, useMemo } from "react";
import "./Projects.css";

const PROJECTS_DATA = [
      { title: "Drilling Work for TAM Grouting work at T313", client: "JAE HWAN CONSTRUCTION PTE LTD", tag: "LTA", category: "tam", categoryLabel: "TAM Grouting" },
      { title: "Drilling Work and TAM Grouting Work at N102", client: "SSANGYONG-WAIFONG JOINT VENTURE", tag: "LTA", category: "tam", categoryLabel: "TAM Grouting" },
      { title: "LSS Coring and Drilling/Installation of TAM pipe at TWRP", client: "Jae Hwan Construction Pte Ltd", tag: "PUB", category: "tam", categoryLabel: "TAM Grouting" },
      { title: "LSS Coring and Drilling/Installation of TAM pipe at TWRP", client: "Jae Hwan Construction Pte Ltd", tag: "PUB", category: "tam", categoryLabel: "TAM Grouting" },
      { title: "TAM grouting Work at MH04 at Jalan Buroh for DTSS 2 Link Sewers", client: "JAE HWAN CONSTRUCTION PTE LTD", tag: "PUB", category: "tam", categoryLabel: "TAM Grouting" },
      { title: "TAM grouting Work at Pasir Ris Industrial Ave 1", client: "Takenaka Corporation", tag: "Private", category: "tam", categoryLabel: "TAM Grouting" },
      { title: "TAM grouting Works at Selegie", client: "Be Time Engineering Pte Ltd", tag: "Private", category: "tam", categoryLabel: "TAM Grouting" },
      { title: "TAM grouting Works at DTSS Link Sewer Mh11 LK11C4", client: "MK Tunnel Pte Ltd", tag: "PUB", category: "tam", categoryLabel: "TAM Grouting" },
      { title: "Construction of Tunnels from Elias road to Punggol P103", client: "Sindong Geological Engineering Pte Ltd", tag: "LTA", category: "tam", categoryLabel: "TAM Grouting" },
      { title: "Pipe Jacking Work at Pulau Punggol Barat", client: "ASK M&E PTE LTD", tag: "PUB", category: "jacking", categoryLabel: "Shaft & Pipe Jacking" },
      { title: "Drilling work for Recharge Well for N105", client: "Knights Synergy (S) Pte Ltd", tag: "LTA", category: "recharge", categoryLabel: "Recharge Well" },
      { title: "Recharge well Link Sewers LK11C4", client: "MK Tunnel Pte Ltd", tag: "PUB", category: "recharge", categoryLabel: "Recharge Well" },
      { title: "Recharge Well Work at DTSS Phase 2 Link Sewers Schedule 2 Contract 3B", client: "Megastones Holdings Pte Ltd", tag: "PUB", category: "recharge", categoryLabel: "Recharge Well" },
      { title: "Recharge well at CR 102", client: "Geo motion Singapore", tag: "LTA", category: "recharge", categoryLabel: "Recharge Well" },
      { title: "Recharge well at DTSS Mh11 LK11C4", client: "MK Tunnel Pte Ltd", tag: "PUB", category: "recharge", categoryLabel: "Recharge Well" },
      { title: "Recharge well works for Link Sewer MH09 LK11C4", client: "MK Tunnel", tag: "PUB", category: "recharge", categoryLabel: "Recharge Well" },
      { title: "Recharge well at CR 106", client: "Geo motion Singapore", tag: "LTA", category: "recharge", categoryLabel: "Recharge Well" },
      { title: "Recharge well at CR 107", client: "Geo motion Singapore", tag: "LTA", category: "recharge", categoryLabel: "Recharge Well" },
      { title: "Recharge well at N106", client: "Geo motion Singapore", tag: "LTA", category: "recharge", categoryLabel: "Recharge Well" },
      { title: "SI work at CR102", client: "GeoMotion Singapore", tag: "LTA", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "SI Works at Various locations", client: "Neo Arch Engineering Pte Ltd", tag: "Others", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "SI work at Farrer park Road", client: "Neo Arch Engineering Pte Ltd", tag: "HDB", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "SI work at CR107", client: "GeoMotion Singapore", tag: "LTA", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "SI Work at Tuas TTP2", client: "Geomotion Singapore", tag: "Others", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "SI Work at Various locations", client: "Be Time Engineering Pte Ltd", tag: "Others", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "SI work at 30 Jurong Port Road", client: "APS ASIA PDA Enterprises Pte Ltd", tag: "Private", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "SI work at Woodlands", client: "Geonamics", tag: "Private", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "SI Work at Changi East", client: "Neo Arch Engineering Pte Ltd", tag: "LTA", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "SI work at Mandai - PUB", client: "Geo motion Singapore", tag: "PUB", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "SI work at Woodlands Exyte", client: "Geo motion Singapore", tag: "Private", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "K7066 DSTA Project", client: "Ryobi Geotechnic SGS", tag: "DSTA", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "Soil Investigation Work at Queenstown", client: "APS ASIA PDA Enterprises Pte Ltd", tag: "HDB", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "Soil Investigation Work at Selatar South street 1", client: "Ryobi Geotechnic SGS", tag: "Others", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "Soil Investigation Work at Tessensohn road", client: "GIE Pte Ltd", tag: "Others", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "Soil Investigation Work at CR103", client: "Geolutions Singapore", tag: "LTA", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "Pumping test - N110", client: "LUM CHANG BUILDING CONTRACTORS PTE LTD", tag: "LTA", category: "pumping", categoryLabel: "Pumping Test" },
      { title: "Pumping test at DTSS Phase 2 Link Sewers Schedule 2 Contract 3B", client: "Megastones Holdings Pte Ltd", tag: "PUB", category: "pumping", categoryLabel: "Pumping Test" },
      { title: "Instrumentation and Monitoring works at Phoenix road", client: "Poh Huat Engineering & Construction Pte Ltd", tag: "Private", category: "instrumentation", categoryLabel: "Instrumentation & Monitoring" },
      { title: "Instrumentation and Monitoring works at Woodlands Ave 5", client: "Poh Huat Engineering & Construction Pte Ltd", tag: "Private", category: "instrumentation", categoryLabel: "Instrumentation & Monitoring" },
      { title: "JGP works for DTSS2 Phase 2 MH04 LK1C4", client: "Megastones Holdings Pte Ltd", tag: "PUB", category: "jet", categoryLabel: "Jet Grouting" },
      { title: "JGP work at Tampines VSMC Project", client: "Takenaka -L&V JV", tag: "Private", category: "jet", categoryLabel: "Jet Grouting" },
      { title: "Drilling and Technical Support for Fissure Grouting for DTSS Phase 2 Link Sewer LK11C4", client: "Jae Hwan Construction Pte Ltd", tag: "PUB", category: "fissure", categoryLabel: "Fissure Grouting" },
      { title: "Fissure and TAM Grouting for DTSS Phase 2 Schedule 1 Contract 4", client: "MK Tunnel Pte Ltd", tag: "PUB", category: "fissure", categoryLabel: "Fissure Grouting" },
      { title: "TAM/FISSURE grouting Work at DTSS Phase Link Sewers 2 Schedule 2 Contract 3B", client: "Megastones Holdings Pte Ltd", tag: "PUB", category: "fissure", categoryLabel: "Fissure Grouting" },
      { title: "FISSURE grouting works at DTSS Phase 2 LK2C1", client: "King View Engineering Pte Ltd", tag: "PUB", category: "fissure", categoryLabel: "Fissure Grouting" },
      { title: "Drilling and Installation of Recharge wells CR106/N106", client: "Geo motion Singapore", tag: "LTA", category: "recharge", categoryLabel: "Recharge Well" },
      { title: "SI work at Tanah Merah Coast Road DE 151", client: "Geo motion Singapore", tag: "LTA", category: "soil", categoryLabel: "Soil Investigation" },
      { title: "TAM grouting work for DTSS2 Phase 2 LK2C1", client: "King View Engineering Pte Ltd", tag: "PUB", category: "tam", categoryLabel: "TAM Grouting" },
];

const CURRENT_PROJECTS = [

  { title: "TAM grouting works at DTSS Phase 2 LK1C4", client: "Megastones Holdings Pte Ltd", tag: "PUB", categoryLabel: "TAM Grouting" },
  { title: "Fissure grouting works at DTSS Phase 2 LK2C4", client: "Megastones Holdings Pte Ltd", tag: "PUB", categoryLabel: "Fissure Grouting" },
];

const FILTERS = [
  { key: "all", label: "All Projects" },
  { key: "soil", label: "Soil Investigation" },
  { key: "pumping", label: "Pumping Test" },
  { key: "tam", label: "TAM Grouting" },
  { key: "fissure", label: "Fissure Grouting" },
  { key: "jet", label: "Jet Grouting" },
  { key: "recharge", label: "Recharge Well" },
  { key: "instrumentation", label: "Instrumentation & Monitoring" },
  { key: "jacking", label: "Pipe Jacking" },
];

/* ── Main Projects Component ── */
const Projects = () => {
  const [isVisible, setIsVisible] = useState({});
  const [activeFilter, setActiveFilter] = useState("all");
  const sectionRefs = useRef({});

  useEffect(() => {
    const observers = {};
    Object.keys(sectionRefs.current).forEach((key) => {
      observers[key] = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [key]: true }));
          }
        },
        { threshold: 0.1 }
      );
      if (sectionRefs.current[key]) {
        observers[key].observe(sectionRefs.current[key]);
      }
    });
    return () => {
      Object.values(observers).forEach((obs) => obs.disconnect());
    };
  }, []);

  const setRef = (key) => (el) => {
    sectionRefs.current[key] = el;
  };

  const filteredProjects = useMemo(() => {
    if (activeFilter === "all") return PROJECTS_DATA;
    return PROJECTS_DATA.filter((p) => p.category === activeFilter);
  }, [activeFilter]);

  const filterCounts = useMemo(() => {
    const counts = { all: PROJECTS_DATA.length };
    PROJECTS_DATA.forEach((p) => {
      counts[p.category] = (counts[p.category] || 0) + 1;
    });
    return counts;
  }, []);

  return (
    <div className="pj-page" id="#projects">
      {/* Top Banner */}
      <section className="pj-top-banner">
        <div className="pj-top-banner__grid" />
        <div className="pj-top-banner__glow" />
        <h1 className="pj-top-banner__title">
          Our <span className="pj-text-accent">Projects</span>
        </h1>
      </section>

      {/* Currently Ongoing Projects */}
      <section
        className={`pj-current ${isVisible["current"] ? "pj-animate-in" : ""}`}
        ref={setRef("current")}
      >
        <div className="pj-current__inner">
          <div className="pj-current__header">
            <span className="pj-current__dot" />
            CURRENTLY ONGOING
          </div>
          <div className="pj-current__list">
            {CURRENT_PROJECTS.map((proj, i) => (
              <div key={i} className="pj-current__item">
                <span className="pj-current__item-tag">{proj.tag}</span>
                <span className="pj-current__item-title">{proj.title}</span>
                <span className="pj-current__item-client">{proj.client}</span>
                <span className="pj-current__item-category">{proj.categoryLabel}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Strip */}
      <section
        className={`pj-stats ${isVisible["stats"] ? "pj-animate-in" : ""}`}
        ref={setRef("stats")}
      >
        <div className="pj-stats__inner">
          {[
            { number: "65+", label: "Projects Completed" },
            { number: "8", label: "Service Lines" },
            { number: "LTA · PUB · HDB under leading main contractors", label: "Key Clients" },
            { number: "Private projects", label: "" },
          ].map((stat, i) => (
            <div key={i} className="pj-stats__item">
              <span className="pj-stats__number">{stat.number}</span>
              <span className="pj-stats__label">{stat.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Filter + Grid Section */}
      <section
        className={`pj-portfolio ${isVisible["portfolio"] ? "pj-animate-in" : ""}`}
        ref={setRef("portfolio")}
      >
        <div className="pj-portfolio__inner">
          <div className="pj-section-label">
            <span className="pj-section-label__line" />
            TRACK RECORD
          </div>
          <h2 className="pj-section-title">
            COMPLETED
            <br />
            <span className="pj-text-accent">PROJECTS</span>
          </h2>
          <p className="pj-portfolio__subtitle">
            Browse our project portfolio by service type — from soil investigation
            to specialised grouting and trenchless construction works.
          </p>

          {/* Filter Tabs */}
          <div className="pj-filters">
            {FILTERS.map((f) => (
              <button
                key={f.key}
                className={`pj-filter-btn ${activeFilter === f.key ? "pj-filter-btn--active" : ""}`}
                onClick={() => setActiveFilter(f.key)}
              >
                {f.label}
                <span className="pj-filter-btn__count">{filterCounts[f.key] || 0}</span>
              </button>
            ))}
          </div>

          {/* Projects Grid */}
          <div className="pj-projects__grid">
            {filteredProjects.map((proj, i) => (
              <div key={i} className="pj-project-card">
                <div className="pj-project-card__top">
                  <span className="pj-project-card__category">{proj.categoryLabel}</span>
                </div>
                <h4 className="pj-project-card__title">{proj.title}</h4>
                <div className="pj-project-card__footer">
                  <span className="pj-project-card__client-label">Contractor</span>
                  <span className="pj-project-card__client">{proj.client}</span>
                </div>
              </div>
            ))}
          </div>

          {filteredProjects.length === 0 && (
            <p className="pj-projects__empty">No projects found for this category.</p>
          )}
        </div>
      </section>

      {/* CTA Banner */}
      <section className="pj-cta">
        <div className="pj-cta__inner">
          <div className="pj-cta__left">
            <p className="pj-cta__label">READY TO START?</p>
            <h2 className="pj-cta__title">
              HAVE A PROJECT
              <br />
              <span className="pj-text-accent">IN MIND?</span>
            </h2>
            <p className="pj-cta__desc">
              Our team is ready to mobilise. Get in touch for a detailed quote
              and consultation tailored to your project's requirements.
            </p>
          </div>
          <div className="pj-cta__right">
            <a href="/contact-us" className="pj-btn pj-btn--primary pj-btn--large">
              CONTACT US →
            </a>
            <div className="pj-cta__contacts">
              <span>Nedu: +65 9239 8494</span>
              <span>Suben: +65 9027 1160</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;